import type { ComponentProps } from 'react';

export const TrashIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        clipRule='evenodd'
        d='M15 4H9V2H15V4ZM5.06888 8H3V6H4.92602H6H18H19.074H21V8H18.9311L17.9975 21.0712L17.9311 22H17H7H6.06888L6.00254 21.0712L5.06888 8ZM7.07398 8L7.93112 20H16.0689L16.926 8H7.07398Z'
        fill='black'
        fillRule='evenodd'
      />
    </svg>
  );
};
